 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AdminLayout":"AdminLayout","AdminLogin":"AdminLogin","AdminSignup":"AdminSignup","CustomerDashLayout":"CustomerDashLayout","CustomerEdit":"CustomerEdit","CustomerLoginPhoneView":"CustomerLoginPhoneView","CustomerLoginView":"CustomerLoginView","CustomerSignupView":"CustomerSignupView","EmailVerificationExpired":"EmailVerificationExpired","EmailVerificationSuccess":"EmailVerificationSuccess","EmailVerificationView":"EmailVerificationView","Expired":"Expired","Feedback":"Feedback","ForgotEmailView":"ForgotEmailView","ForgotPasswordView":"ForgotPasswordView","LegacyAccountUpdate":"LegacyAccountUpdate","LegacyAccountUpdateNoEmail":"LegacyAccountUpdateNoEmail","LoginEmail":"LoginEmail","LoginVerifyPhone":"LoginVerifyPhone","MaintenanceMode":"MaintenanceMode","ManageAccount":"ManageAccount","Menu":"Menu","MerchantDashboard":"MerchantDashboard","OrderHistory":"OrderHistory","PasswordResetView":"PasswordResetView","PrintLayout":"PrintLayout","PrintOrderView":"PrintOrderView","default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder":"default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder","AboutView":"AboutView","Help":"Help","Home":"Home","Invoice":"Invoice","ManageShopSettings":"ManageShopSettings","NewOrder":"NewOrder","default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard":"default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard","ManageIndexView":"ManageIndexView","ManageMenuOrderView":"ManageMenuOrderView","ManageOrderPrepView":"ManageOrderPrepView","MerchantSupport":"MerchantSupport","SuperAdminDashboard":"SuperAdminDashboard"}[chunkId]||chunkId) + "." + {"AdminLayout":"9d777eb3","AdminLogin":"f053454d","AdminSignup":"3a6d5e14","CustomerDashLayout":"1a841921","CustomerEdit":"6cef3747","CustomerLoginPhoneView":"4a347952","CustomerLoginView":"5236a6b1","CustomerSignupView":"befa6536","EmailVerificationExpired":"7b12b6c2","EmailVerificationSuccess":"ee73cf8f","EmailVerificationView":"06351318","Expired":"f1c54c60","Feedback":"c02950a8","ForgotEmailView":"cdc56db0","ForgotPasswordView":"eabd663c","LegacyAccountUpdate":"315e64cf","LegacyAccountUpdateNoEmail":"e8efe905","LoginEmail":"2d3092b6","LoginVerifyPhone":"002a25a7","MaintenanceMode":"5750a33d","ManageAccount":"1178edf9","Menu":"c922a2d3","MerchantDashboard":"eb9be8f4","OrderHistory":"62724574","PasswordResetView":"fad6e897","PrintLayout":"ef14e0c7","PrintOrderView":"c03fa54b","default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder":"0909ab95","AboutView":"bb10a093","Help":"7d7ae030","Home":"44e8fbe3","Invoice":"787b2443","ManageShopSettings":"8132e697","NewOrder":"dfac78fc","default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard":"7fa80d2a","ManageIndexView":"bbad0d92","ManageMenuOrderView":"65b8e136","ManageOrderPrepView":"97ce8176","MerchantSupport":"089c7d7b","SuperAdminDashboard":"0175fc86"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AdminLayout":1,"AdminLogin":1,"AdminSignup":1,"CustomerEdit":1,"CustomerLoginPhoneView":1,"CustomerLoginView":1,"CustomerSignupView":1,"EmailVerificationExpired":1,"EmailVerificationSuccess":1,"EmailVerificationView":1,"Expired":1,"Feedback":1,"ForgotEmailView":1,"ForgotPasswordView":1,"LegacyAccountUpdate":1,"LegacyAccountUpdateNoEmail":1,"LoginEmail":1,"LoginVerifyPhone":1,"ManageAccount":1,"Menu":1,"MerchantDashboard":1,"OrderHistory":1,"PasswordResetView":1,"PrintOrderView":1,"default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder":1,"AboutView":1,"Home":1,"Invoice":1,"ManageShopSettings":1,"NewOrder":1,"ManageIndexView":1,"ManageMenuOrderView":1,"ManageOrderPrepView":1,"MerchantSupport":1,"SuperAdminDashboard":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AdminLayout":"AdminLayout","AdminLogin":"AdminLogin","AdminSignup":"AdminSignup","CustomerDashLayout":"CustomerDashLayout","CustomerEdit":"CustomerEdit","CustomerLoginPhoneView":"CustomerLoginPhoneView","CustomerLoginView":"CustomerLoginView","CustomerSignupView":"CustomerSignupView","EmailVerificationExpired":"EmailVerificationExpired","EmailVerificationSuccess":"EmailVerificationSuccess","EmailVerificationView":"EmailVerificationView","Expired":"Expired","Feedback":"Feedback","ForgotEmailView":"ForgotEmailView","ForgotPasswordView":"ForgotPasswordView","LegacyAccountUpdate":"LegacyAccountUpdate","LegacyAccountUpdateNoEmail":"LegacyAccountUpdateNoEmail","LoginEmail":"LoginEmail","LoginVerifyPhone":"LoginVerifyPhone","MaintenanceMode":"MaintenanceMode","ManageAccount":"ManageAccount","Menu":"Menu","MerchantDashboard":"MerchantDashboard","OrderHistory":"OrderHistory","PasswordResetView":"PasswordResetView","PrintLayout":"PrintLayout","PrintOrderView":"PrintOrderView","default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder":"default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder","AboutView":"AboutView","Help":"Help","Home":"Home","Invoice":"Invoice","ManageShopSettings":"ManageShopSettings","NewOrder":"NewOrder","default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard":"default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard","ManageIndexView":"ManageIndexView","ManageMenuOrderView":"ManageMenuOrderView","ManageOrderPrepView":"ManageOrderPrepView","MerchantSupport":"MerchantSupport","SuperAdminDashboard":"SuperAdminDashboard"}[chunkId]||chunkId) + "." + {"AdminLayout":"ce9389d6","AdminLogin":"8faac380","AdminSignup":"492b815f","CustomerDashLayout":"31d6cfe0","CustomerEdit":"bd7ef48b","CustomerLoginPhoneView":"a0221ee7","CustomerLoginView":"a0221ee7","CustomerSignupView":"6f670b44","EmailVerificationExpired":"a0221ee7","EmailVerificationSuccess":"a0221ee7","EmailVerificationView":"a0221ee7","Expired":"40b6964c","Feedback":"5e90908b","ForgotEmailView":"a0221ee7","ForgotPasswordView":"a0221ee7","LegacyAccountUpdate":"a8ed5794","LegacyAccountUpdateNoEmail":"a8ed5794","LoginEmail":"704f0f3a","LoginVerifyPhone":"4d2f5747","MaintenanceMode":"31d6cfe0","ManageAccount":"7bb10b68","Menu":"22e507e9","MerchantDashboard":"e97e1e38","OrderHistory":"ad28ccd8","PasswordResetView":"6f670b44","PrintLayout":"31d6cfe0","PrintOrderView":"db7d9532","default.AboutView.Help.Home.Invoice.ManageShopSettings.NewOrder":"b3929452","AboutView":"99575a59","Help":"31d6cfe0","Home":"882c3b05","Invoice":"5d58e1b9","ManageShopSettings":"ac369ef9","NewOrder":"b33cc86c","default.ManageIndexView.ManageMenuOrderView.ManageOrderPrepView.MerchantSupport.SuperAdminDashboard":"31d6cfe0","ManageIndexView":"68da5754","ManageMenuOrderView":"edd3f99c","ManageOrderPrepView":"594b9bf8","MerchantSupport":"277a6ded","SuperAdminDashboard":"0668e1e3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
